import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CustomCheckbox, CustomInput, CustomPassword } from "shared/components/allInput";
import CustomButton from "shared/components/inputButton";
import formValidation from "utils/validations";
import { showFormErrors } from "utils/CommonFunctions";
import { useDispatch } from "react-redux";
import { RegisterAction, requestOtpAction } from "store/actions/AuthActions";
import OtpVerification from "./OtpVerification";

export default function SignUp() {
  const dispatch = useDispatch()
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    updateIO: false,
    iAgree: false
  })
  const [loading, setLoading] = useState(false)
  const [isVerifyOtp, setIsVerifyOtp] = useState(false)
  const navigate = useNavigate();

  const onSubmit = async () => {
    if (showFormErrors(data, setData)) {
      dispatch(requestOtpAction({ email: data?.email, otpType: 1 }, setLoading, dispatch, (res) => {
        setIsVerifyOtp(true)
      }))
    }
  };

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data)
    setData((prev) => ({ ...prev, [name]: value, formErrors }))
  }

  return (
    <>
      {!isVerifyOtp ?
        <>
          <h2 className={`text-2xl md:text-4xl text-left py-1 mb-2 `}>
            Welcome to
            <span className="color-sycamore"> athena-io.</span>
          </h2>
          <p className="text-lg text-left">Create an account to get started.</p>
          <form className="mt-5 pt-2">
            <CustomInput name="name" data={data} onChange={handleChange} col={12} />
            <CustomInput name="email" data={data} onChange={handleChange} col={12} />
            <CustomPassword name={"password"} data={data} onChange={handleChange} />
            <CustomPassword name={"confirmPassword"} data={data} onChange={handleChange} />
            <CustomCheckbox label={"Yes, I’d love to be updated on athena-io."} col={12} name="updateIO" onChange={handleChange} data={data} />
            <CustomCheckbox label={"By signing up, I agree to the Terms of Service and Privacy Policy."} col={12} name="iAgree" onChange={handleChange} data={data} />
            <CustomButton label="Sign Up" extraClassName="my-5 w-full" onClick={onSubmit} loading={loading} disabled={!data.iAgree} type="button" />
            <p className="mt-2 text-center">
              Have an account?{" "}
              <Link to="/login" className="underline color-black">
                Log In
              </Link>
            </p>
            <div className="h-2rem"></div>
          </form>
        </>
        :
        <OtpVerification data={data} type={1} />
      }
    </>
  );
}
